import { reactive, ref } from "@vue/composition-api";
import _axios from "@/axios";
import { showSnackBar } from "@/composables/snackbar";

let MACAddresses = ref([]);
export function useAuthentificationMAC() {
  const macAddressData = reactive({
    isDeleted: false,
    firstLoad: true,
    isLoading: true,
    deleteDialog: false,
    options: {},
  });

  function listAuthentificationMAC(filters = null) {
    macAddressData.isLoading = true;

    const params = new URLSearchParams();
    if (filters != null) {
      if (filters.mac != "" && filters.mac != undefined) {
        params.set("mac", filters.mac.trim());
      }
      if (filters.client != "" && filters.client != undefined) {
        params.set("client", filters.client);
      }

      if (filters.card != "" && filters.card != undefined) {
        params.set("card", filters.card);
      }
    }

    params.set("page", macAddressData.options.page ?? 1);
    params.set("itemsPerPage", macAddressData.options.itemsPerPage ?? 100);

    return _axios
      .get("/list-authentification-mac?" + params.toString())
      .then((response) => {
        MACAddresses.value = response.data;
      })
      .catch(() => {
        alert(
          "Une erreur est survenue, si cela se reproduit contactez le support"
        );
      })
      .finally(() => {
        macAddressData.firstLoad = false;
        macAddressData.isLoading = false;
      });
  }

  function deleteAuthentificationMAC(cardId, mac, filters = null) {
    return _axios
      .delete("/authentification-mac/" + cardId + "/" + mac)
      .then(() => {
        listAuthentificationMAC(filters);
        showSnackBar();
      })
      .catch(() => {
        alert(
          "Une erreur est survenue, si cela se reproduit contactez le support"
        );
      });
  }

  return {
    MACAddresses,
    macAddressData,
    listAuthentificationMAC,
    deleteAuthentificationMAC,
  };
}
